var _path, _rect, _path2, _path3, _image, _path4, _image2, _path5, _image3, _path6, _div, _image4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path7, _path8, _path9, _path10, _path11, _path12, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _path13, _g19, _g20, _g21, _g22, _path14, _path15, _path16, _g23, _g24, _g25, _path17, _g26, _g27, _path18, _path19, _path20, _path21, _g28, _g29, _g30, _g31, _path22, _g32, _path23, _g33, _g34, _g35, _path24, _path25, _path26, _path27, _g36, _g37, _g38;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolarStandard = function SvgSolarStandard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 883,
    height: 635,
    viewBox: "-0.5 -0.5 883 635"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 0
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 1
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "o5JlLGx5UqJ8qpOX4e-e-1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.22 40h818v560h-818z",
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-1",
    pointerEvents: "all"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 760,
    height: 520,
    x: 59.22,
    y: 60,
    stroke: "#000",
    strokeWidth: 0.1,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-2",
    pointerEvents: "all",
    rx: 36.4,
    ry: 36.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0ff",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M841.34 0c0 21.9 17.76 39.66 39.66 39.66v552.68c-21.9 0-39.66 17.76-39.66 39.66H40.66c0-21.9-17.76-39.66-39.66-39.66V39.66C22.9 39.66 40.66 21.9 40.66 0ZM80.32 39.66a79.32 79.32 0 0 1-39.66 39.66v473.36a79.32 79.32 0 0 1 39.66 39.66h721.36a79.32 79.32 0 0 1 39.66-39.66V79.32a79.32 79.32 0 0 1-39.66-39.66Z",
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-3",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-5"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M291.9 255.9h296v116.2h-296z",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("switch", {
    transform: "matrix(2 0 0 2 -.5 -.5)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 146,
      height: 1,
      paddingTop: 157,
      marginLeft: 147
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFB570;",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 52,
      fontFamily: "&quot",
      color: "#ffb570",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Solar")))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAkgAAAEsCAYAAAA4k0x+AAAgAElEQVR4Xu2df4ilV5nn763KfyoLCo6bjQiGCQmiGxMJw8Y2EtiY2M3MKrM9xMXFmZhBSUJXfiyKxBVjGFxI7DQm47CTRDGMjXEZdUnFmIWQjGkZwphpe5E0M3SDbMxqwwpO0v9V17vPufdU9a3qW/ee997n/Hw+BZdb3XXe857zeZ73nO/7nF/DAT8QgAAEIAABCEAAAjsIDOEBAQhAAAIQgAAEILCTAAIJj4AABCAAAQhAAAK7CCCQcAkIQAACEIAABCCAQMIHIAABCEAAAhCAwGwCRJDwEAhAAAIQgAAEIEAECR+AAAQgAAEIQAACRJDwAQhAAAIQgAAEINCLAENsvXCRGAIQgAAEIAABCwQQSBasTB0hAAEIQAACEOhFAIHUCxeJIQABCEAAAhCwQACBZMHK1BECEIAABCAAgV4EEEi9cJEYAhCAAAQgAAELBBBIFqxMHSEAAQhAAAIQ6EUAgdQLF4khAAEIQAACELBAAIFkwcrUEQIQgAAEIACBXgQQSL1wkRgCEIAABCAAAQsEEEgWrEwdIQABCEAAAhDoRQCB1AsXiSEAAQhAAAIQsEAAgWTBytQRAhCAAAQgAIFeBBBIvXCRGAIQgAAEIAABCwQQSBasTB0hAAEIQAACEOhFAIHUCxeJIQABCEAAAhCwQACBZMHK1BECEIAABCAAgV4EEEi9cJEYAhCAAAQgAAELBBBIFqxMHSEAAQhAAAIQ6EUAgdQLF4khAAEIQAACELBAAIFkwcrUEQIQgAAEIACBXgQQSL1wkRgCEIAABCAAAQsEEEgWrEwdIQABCEAAAhDoRQCB1AsXiSEAAQhAAAIQsEAAgWTBytQRAhCAAAQgAIFeBBBIvXCRGAIQgAAEIAABCwQQSBasTB0hAAEIQAACEOhFAIHUCxeJIQABCEAAAhCwQACBZMHK1BECEIAABCAAgV4EEEi9cJEYAhCAAAQgAAELBBBIFqxMHSEAAQhAAAIQ6EUAgdQLF4khAAEIQAACELBAAIFkwcrUEQIQgAAEIACBXgQQSL1wkRgCEIAABCAAAQsEEEgWrEwdIQABCEAAAhDoRQCB1AsXiSEAAQhAAAIQsEAAgWTBytQRAhCAAAQgAIFeBBBIvXCRGAIQgAAEIAABCwQQSBasTB0hAAEIQAACEOhFAIHUCxeJIQABCEAAAhCwQACBZMHK1BECEIAABCAAgV4EEEi9cJEYAhCAAAQgAAELBBBIFqxMHSFgiEC3vnazVPc7WlUe7n+IdlILJvlAoCICPPgVGYuiQgAC8wkgkOYzIgUEIDCfAAJpPiNSQAACFRFAIFVkLIoKgYIJIJAKNg5FgwAE+hNAIPVnxhUQgMCFBBBICl7RPX3nDYOue5tkdf04u+6SwWB48UTW7+txm9OS9o2J9K/L76+Ms+1+NxgOfzb6fWPjheEfPfxaj3xJCgETBBBIJsxMJSEQnQACqQfi7oe3Xzy46KLrvBC6Qr5/Xz5v75FFjKRbguqkCKj/MxJQiKcYnMmzEgIIpEoMRTEhUDgBBNIMA3lB9DFJ8iH5fEA+7y7cnpPFOyv/OCWfl+RzfDBc+enwo1/7x4rKT1EhsBABBNJC2LgIAhDYRQCBtAvIWBSt/pkMkd0of7q2MY85I+N0Lw+6wS8GKyvPDj96+NnG6kd1IDBAIOEEEICABgEEkqcojept8qvbP6U1UTTLT1yU6biIpmcGw9V1IkwajxR55CaAQMptAe4PgTYImBZIfgjty2LKP5RP7rlEJXiURJgGz8vnB7I53tESCkQZINCXAAKpLzHSQwAC0wiYFEjd03e9f9Btfl6A7JfPm3CNqQQkutT9RIYan5JJ399nxRxeUgsBBFItlqKcECibgCmB5CNGh8UkB8s2S4mlk2E4EUsSWXqkxNJRJghsEUAg4QsQgIAGATMCqXvq0AOyBP4zRIyWdptxZGm4cphJ3kuzJIMIBBBIEaCSJQQMEmheIPnG8n6xbU1L9GtxRdmDqfvmYOPc4wzB1WKy9suJQGrfxtQQAikINCuQGE5L4T7b93Cr4Y7K8NutSe/KzSAwhQACCbeAAAQ0CDQpkPzRH98gaqThIsF5nBCB9G+DU5MQApEIIJAigSVbCBgj0JxA6tYP3SuTid0KNVanpXVmBFJa3txtDwIIJFwDAhDQINCUQBJx9CO/A7YGG/LoRwCB1I8XqSMRQCBFAku2EDBGoAmB5OcbPSm2s7QLdmmuikAqzSJGy4NAMmp4qg0BZQLVCyQvjmRDQ1apKftG3+wQSH2JkT4KAQRSFKxkCgFzBKoWSIijovwVgVSUOewWBoFk1/bUHAKaBKoVSIWKoxOyL9BrMg/qVfn+pXyfGhlruHJy3kGw/viTy71x3yrfV/rfr5Dvt8jnUvmUPPEcgaT5ZJLXwgQQSAuj40IIQGCCQL0CaX3NiY+cmz/Kwa7dy1KGYyKAXkqxq7QXhdcNuu7qwXDwHlFel2VmMPkwIZBoWooggEAqwgwUAgLVE6hSIGVcrTY+7X44fCyFIAr1Lt8hXC/pr5HP+0KvU06HQFIGSnaLEUAgLcaNqyAAgZ0EqhNIfp+jr6Q15Oig1m/LRohH0953sbtJB3GbXPkh+XxYPm9fLJfeVyGQeiPjghgEEEgxqJInBOwRqEog+R2yf5zOTCKMhqtfmDd/KF15+t9pxGxz8waJen1Mro45JIlA6m8erohAAIEUASpZQsAggboEUrp5RydkXtGnahZG03zZC8xbIkWWEEgGG5ASq4xAKtEqlAkC9RGoRiBJo/fXgvfTkRG7Q1c/J0Npj0S+T/bs/TDczVIQrc01EUjZrUoBHAEEEn4AAQhoEKhCIPkl8G4zyJjL3E9L1OiPW4sazXMSz9adXbd/Sb4IpHmw+XsSAgikJJi5CQSaJ1CHQIp+xlr3zHD/kZuat/aMCo62EFhdvUvmKn1Ski0ysRuBZNmBCqo7AqkgY1AUCFRMoHiB5CMcbr+hWD+PypDarbEyrzFfv1Lwjp5CCYFUo7EbLDMCqUGjUiUIZCBQvkCKGz1CHM2KKo3nfbl5SiFDmwikDA8wt7yQAAIJr4AABDQIFC2Q4kaPGFYLcSC/e/dhSXtwTnoEUghQ0kQngECKjpgbQMAEgbIF0lOHHpA5MXdHsMRpGVZzZ5vxE0jAbxHwDUm+115KCKRAliSLSwCBFJcvuUPACoGyBdL62m/EEItMGJ5tv+HwIyUdFVKTs3V7i1YEUk2GbLisCKSGjUvVIJCQQLECKeKu2cw7WtLB9ogmIZCW5MrlOgQQSDocyQUC1gmUK5DiDK+dHWxsXDb8o4dfs274Zes/npu0+picUXejzwuBtCxUrlchgEBSwUgmEDBPoFyBtL72c7GO9sn0T8rcoz8xb3VFABOHByOQFLmS1eIEEEiLs+NKCEDgPIGSBVKnbqjhylXWdspWZ0iGECicAAKpcANRPAhUQqBIgaTdwHlbsHKtEqekmBBYhoB2+yFR5yLbyWUYcS0EIDCfQJEP/sSwzfwahKdgeC2cFSkhUC0BBFK1pqPgECiKQKECabSD86eVSd0ub4KPKOdJdhCAQGEEEEiFGYTiQKBSAqUKpBeF57XKTD8hAumocp5kB4G5BMYddicbkw7fJd+XyPfF/qJ3yPesfb7Oyt9P+bSvy/crg677nWye+jNZjfkCqzGno0cgzXXJoAR+O4+3nffd0WVXyOctExm4DXdDjiJyl5yRz6/PX9vJauLhq/7fz42+8esg25AoDYFSBZL6CjbmEaRxKOt3GXUqm5s3DIaD90jjf9UcAbQsLiegjo+E02DwHC8AY5wIpHC38kcJXSfC+2oR3u+UKy+XzzzhHn6DxVOeEEu+NugGv3AvBPj24iC5cnECCKTF2XElBLY65NukMT+QQBDNI+4FU/fMYOPc41YjTAik6W4yjghtXjOOZA7ke9An+jPP91L8XUTT4CVeBlKg5h6OQKkCSX2JPxEkHF6TgB9+uEXy3C+f0CEGzSIE5CVCaTD8trW3bwSSyPXzYui9PiqkvadcgP9FTSIvA91PLPm3+LXm3Nzk+9btEa10ThIi1J04lp/tYVkXOf9t7LYNgRT1GSbz1ghIIyXRosGfy6emDkfmfnRfH+4/cn9r9phWH4sCydf5euHh5ghdWa5oj+KBZ2SI8InBuXNfazlqWqNA8u3lh8TqH5DPXgedL+sUZ2UY9uMxzldFIC1rGq43QcA/6P9VKqt/eHI6giaEkiWB5LdE+bwxQbTXE+OGmI/KRO8vtSiUahFIvq2UhSnqC61mtZRRFmGZEUiiMD8SQ2Gm69u4Uw4CvrN1HVBNEaN5qNxqovta3fbClkBSHXaZ5ze1/H0klMS/b62lwCHlLFkgdU/f9X6Z3+bayVxTDhBIIU40I00UgEuWicsLJeDHyw9L8Q4WWkSNYp0YDFc+1drxOwgkDddoIg/3IrAWe55KKlIlCqSxMDr3FxOHlqfCsfs+Ufr3UiNI6sv8ZYz6weGBI/fksh73rYeA72AfkhLXPJwWCvysPBt/1dKzgUAKNb2ZdI+2EE0qSSAVJIy2nBiBtOTjzFEjSwK0cLk0Qt9tPGq0lxmPydyNgy3M3UAgWXhSe9fxtPj3vpr9uwSBVHBkHYHU+5HYeQGH1S4JsOXL/YP/I6ljS3ON+prstMzV+2ztc/UQSH3NbiZ9tNVOKQjmFkjdU4cekPbhM1LXErc1MSWQNPd7OO+7w5WrWptvkeLBbP0efk+jJ4wMqc0zp5vgemvN8zYQSPNMbPrv1YqkXALJt4/fEK+JtUxfwyERSEtTZB7S0ghby8A//H9b6FtRRtzdF2vdNwmBlNFt6rh1lSIph0BSvmdM7zAlkNweCt+JQPOMvBn/XoR8ybJCAoijeUarUyQhkObZlb8LgbMyJ+mymuYkKYuVmTtpVxI1mnRkQwJpvKfCy5Ee4yggI5WVbCMRQByFgq1PJCGQQm1rPl1V81JTCSTl+6Rysij9epHL/B1RMdIbkYY9iCKlctlC74M46muYukQSAqmvfU2nr2Z1s7JwuSCCVPlCFXMC6UV5bK+N9Og2sS9GJDZNZ+sbgX+KJL7bZVfRTvQIpHbdMFLNonSu2mWNKZD8M+MWR5W4Qi0EZRQblhtBGi8pvDuEzEJpKmrwF6ofF11AwIsjOQE822qM0xIbFXE2fFXK8NyogBsbL+w1D8I3WnJJd7U8C++U1JfLJ9c2BDKxdWVfDatAEUjRHn53ovrr8nlFfPJ34pM/G91pOPx/87aG8FHbt/mSvVW+3YG67uca/53Lr93tqxhViCWQlPON5nxzMjYmkOLOQ3Ksq1zJkMv7WrivHOwp+xwNb0xYF1ky34kgGz4lQuj7WhNCvQD4D1KPD8sn5W7fVWy2h0Ba2sPdER3/PBJCTsgPV06mEMZjEbXpBJOMHAz3yXe6aEYFK5yVhcwJaZNuGlx0USt7v9kSSO4RF4c4JV8x915AJC3dltaRgd/kLF5EcicGedPuvpdimbwXA7eNO5UUP90zUq+bUtxp0XsgkHqTk8jm4B/k83cihn6aQgyFlFDsKH7dHUj0UlP8qjZlgeREsPtJ+YIVYvZF0xgUSLGH2camaO4sqkU9rNXrEk7KdkMQX82xyaI/TfvriYTS7VLHR0r1FwTSXMv4yOZAjpc597hWZHPuXRdMkOzcr8KjSMoCaUFrFHuZQYEUf5ht0tpNnmxerDsnLFiSSOSgE2F05P6E1Zp6Ky8OYh+0W/TbNgJpqmuMo0TD4WPz5gvl9uG97u9fAr4lf481X6nouUgIpJmeaU8gORyJ5424YxaOytjsl0p/qyq1ESutXAmG1kZj+SX5S6IDJY9JFOmDpdl73GasqW40K/UsdzHL+tqsY5lOy2Tq7w9WVv+mlGEzDX+JLBSKjY5GrreGaXbnMbko5bj88bfz5rP5tuu6iYyu979fId//Wj57TbmxKpB0G7tAL3BCaV2M+dWWGpbAujeTzL9xulVrsSZ7Fr1dhLxc3CvzN74S0aBRGqVly2tcILm5Jc/XHCkKsX883y53jl0FAkl8r5MNnnUXpez2h/OT+Yfvlb99wIumKG1RsW9Gk1DEMX4eMaw673kcTbitYax+XkWs/T1u9LGOzRMjz78qckjCpkDqnnEdU8lzw7Tbn0gi6awwfLN2WTXyK1Qgba3U/XaOuZcaXGflUYdAGi3/7H4cG0ZA/sekHH/fWsg6oN7VJdHuJHcCqEMcbZU5qkgqcGKrtu1LHmKr7sFULnCkl6Aih9kKE0hnpC98YnDu3NdKml6g7F6DKgSSq7Q4x3fl66A2gCXy8+FEWQkyXHmp1omPS9S/6EvjRR3rEkcJRFJxE7YRSEU/mqqF83NW/lEy1VyuXuTxI4UIJNfvfb2EBSmqjrRHZvUIpB/efrFsalX6ERFumfdJcaD/jWhK4b7T76HdQU7cpciGM5R0pCEJd/ui5mJp258IUqiH5UkXwa9nnnSfp5ajIMGsCfmxi+WG0opYqRu7opP5VyOQfBTJbYj3cEpACvdyc5heG3SDX4y25p9xtITCvchiHG2MMWetyEazr8EjRWKLmreBQOrrFfWnF5v/RjOKVKIoziSQTK/srkogeZFU2lDbIq2LW2nya/m8JN35L2Vy5akWJ7gtAmbZa/zKNVlJofpT3DDSMrWLsy9UOUOPCKRlvKPOa9W38yjwrM4MAslNH7nD8kru6gSSF0kxIgQltAyTZyAdL2nb/xLghJQhzqTNcjr/EAbz0vhJ29qLHk6LyL903r1T/B2BlIJyWfeI8GJU3ETthALJ9UP3WVoRuZc31ymQxvORcp7Knrp1YG5TAHE/YVN7nloTQ2u78UUZaivkrRuBFPCwNJhEOTJa1Lw6HxhIMAdJtovYOHdLyyvT+rh+lQJp5CzjY0hibgLYh2OOtBOiaXXdchh0C36EyZou6ygbkOVwmMl7xhGTZWyyh0DK7V157q8s+otbkBE5guTmGn2OqNFO361WII1F0mh/pCfkV80lnnme7uXvOh6eG+3TtPKsxW0HpAF5URhonmrfZPTovKBUXxVTxGRtBNLyjUmNOSjPQyru2Y8okIo7LqkU/6taII1Ekr3htlDfcW8Ecv6NhEyH7UeYvB/8KhROYLomo0fbAmn87Ggzyz53A4EU6N2NJVO2uxWBVNxQYkluWb1AmhBJTypHD0qyk0ZZmjy48nw0RP3csSKP0dBwhB1DbeuHfiSrKG/Uyzf/MJtyRzkoccm3nr3ayUnZ7q0LJIbUAly/CYEUccggAGGVSdwpy99s6Xw59eG1Ao/QiOFpEVa0ZR9mU+4oEUgxHC9SnmL7Tinr7H68ux7KQ2zFCUAlu6lm05RAGkWTmJfUx0HGBw0OVw7XPmdJsWEc8xuuXGVl4rv2JnuyIepHcvoTAqlPE9BWWs12oLTIIQIpva82J5Amhty+LL9/Oj3Sau/oVsXJVvIPHa2tBtodotTf1NuV8uof5z5Z5zVo+0NpHWVtz2fK8iKQgmmbauOCqexK2KRA2qqj3wrgW/Lv9y0KyOB11Qkl5TcrCap1Dw4PHLnHiu0jDLNlbXwRSFY898J6IpCCbZ/1GQ0uZeaETQukbaG0vnaz/P55hFIvbzshw0yfqmGYSRpF3Z3VDQ2vTTwjb8jvb+rlITMS54y6IJC0rFhfPgikYJshkAJQmRBICKUAT9g7yaNywO6XSt5ZVbNRFAwmVq/tNneEI1qybZGAQFrqec9+sd+y47rtgnTd1TKv7V9NFOyaXYV8h/xbfS+8nCJ/mhGUI+UIpABPNyWQtoXSaCL35p0yE3ef5ltzAO9ak5yRBuqTOSfe7gVOf3go/zL1HE6ivMle1mFKBFIOD5p9T28Tl+it8rlynLq7RNrgi/2VUUTOMiQQSMvQa+NakwJpWyiNNspb/TN5SP9U/u/dbZg0ai2yTr6d/lalvP+RsflHO18aOsUDbPMJTQRS1Dbggsz9S8rbZO7eVqTnCkn0Fvm8ueZ2FYGU1o9KvJtpgTRpkNGE7s1z/0kiJR+r+aFO4GTHZMjtYClDbsphZ4cv29BQAtvNvIXyUGW2ED4CKY4n+UUv/85HgNwwV9UCaB4lBNI8Qu3/HYE0xcbjMXAXWXLnejEMNwXRaRFJ+0oQSdoTtEtrFFM2Qa2wRCDpeI3neL3k5sTQpfJRm8SvU8K4uZTWFii/DGZ7gYlrNd3cEUgBPMch5E3XSDjBdJV8q08IDChGaUmKmJekvMmhyQnaW46lPlE702pABNJiTcWondvcvEGi6P9ecjC/NQoCaTE/aukqBNIC1pxYZSFvV6OJhpdJNhbnMJ2VrQD25dwKoJVhoQXcUP0S5TdUV74sw5UIpHDX8POHbpErPsyL305uCKRwP2o1JQJJ0bKjhnk8UfGdku3lRt7Csg23+TkRLyua8ElpFP9EMb+qshL/vU0K/LBeobsvDvcfuV8vv7CcEEizOY1e8FZX73IrUxFFe7NCIIU9by2nQiBFtq7vxJ1Y2oo2uWWtrY3nZxnP1u4IxS7FrdKL7J47sm+Fp3Y9SusoF/UJP1XAbW9y46J5WLquNLsrR3iztNm1+Q8CKZPFzg/TdSKWhu+SYrg5TsXtBdIDT3Jx0UrEowfjqEkjROSS+4QDhEDa6SaeBycJ9Hx6EEg9gTWYHIFUmFG3hdNoqG7wnqrmNyU+xV35jcp5QpY5MyW5YAtzuhBIY4/iLMrlniwE0nL8WrgagVSBFXdOCh9FmkpdYZI0bItA0ndeBNKFTEvrKOdZ3bcXX5Z0n56Xlr/vTaA0uyu3d0nb6lr9DIFUqeV27VFSkGBKNzFXucGQYN3KVTlX5JXgisrbJmRphC1HkHzdHxJfYiuSJR8oBNKSABu4HIHUgBF3bWyZewJmsr2EtPftKa1BzOGayptFJvOFSVZWBZL6C0MOByzonqW1B8r2zfLyUpB5g4qCQArCVE+i82Ip5/lyaaJIyp35oLQGMYfXtcDUmkDyQ2pPir/IRrb8aBEorT1AIGlZNjwfBFI4q+pSZly9cloaF7eVQdSfFjrzqIAWyLwFppYEkhdHPxFTt7hR7Wmp1xvejV+X71cmXPq5SfeW9uao+7fmHDoE0gINSGOXIJAaM+i06mQRSglWtLXQmZfmfi0wtSKQKhRHZ8XfT3mfPynf/+J/Py7fvx39vrHxwjJnPCKQglsUhtgCUCGQAiC1kqR76tADsnvuZ6Q+KQ6djL4rdQudeWm+1QJTCwKpYHHkoj7/dxzt6X4pKx9OyeKHk6kWPyCQglsUBFIAKgRSAKSWkvi9Uf6H1Cl2SD76BN0WOvPSfKsFpq0LpILE0QnxXxcJ+jt58frn4UcPP5vbnxFIwRZAIAWgQiAFQGotiZ/I/Vj0IwciL5tvoTMvzbdaYNq8QFpfe1H8JseEbBcd+gf5/GBrzk+B/ttplYk5SFok680HgVSv7ZYuufYy+QsK1HUPDg8cuWfpgu6RQQudeSw2i+bbAtOWBZIfJr97UfsucN0ZueZ5GSb7aqphsgXKuH0JEaRgekSQAlAhkAIgtZokfqi+e0ZOc78pFr8WOvNYbBbNtwWmrQqk8WGz3Y8XtW3P62T4rPuePL/397wua3IEUjB+BFIAKgRSAKSWk0RudKMu92+hMy/Nt1pg2qxAWl/7ufhL7F3zXcToPhleeqQ03wwpDwIphNIoDQIpABUCKQBS60liDrXFHMeXxlB1LkbMstbiQ8oCKfpE/WlcWxRI8ozeK3MGvxLZjx6VZ+DWyPeImj0CKRgvAikAFQIpAFLrSfzKtpcj1fMTsSZ0SmP411JmvQM5I08qj8RXNVth+hvJUOscryyNcJsCSdUuu33mtKxC+2wJq9CWdWYEUjDBLM9mcOkKSYhAKsQQuYuhHY2ZqE89AmkwiFbW3PYNvb9mB5MrjN+aQIocPTommzMeXGZzxlDfSpFO039LiygrvxAikAIcEoEUAMlCkoiNcLSwvXKD4cyMQFpfU1smjUDSaTnEz93u0xH2LYu7iEKn9v1yQSAF80IgBaBCIAVAspDEr2j7VYS6xhRIt0l5H9Yrc5pDdvXKq5tThKHW6LupTyPQUgQpgk08svbEkasYAim4TUAgBaBCIAVAspIk0ptqTIF0s9jmO4r2iVZWxTJGy0pbWEhBs/DUrkfOoRapy3eF40Flo0ddXapc1l7ZIZCCcSGQAlAhkAIgWUkSaR7SMelgPhiDof4WBW2+VYey1x9mzRORa0wgaQ+vnZVNH/fVsOljqN9OpkMgBVNDIAWgQiAFQLKSJMKcHocu6oOo2SDGLmvpfhTB/lnmdLUikCINe2eJ6qXyfc32IGfkcBov5eczarucyt6x74NAik24ovwjHWMQ9UFUXpZ+VhrFN1dkMtWiqkcQM22b0IxAWl9TnmM3OCsr1i5rZcXaHiJCbZEBAkm1eakyMwRSlWaLU2jtjsWXMrZA0t1deGPj37TcgczyHO05aLk6GG0/zlgP7flHWSbNx2mtpudKBCmYdtR2ObgUhSdEIBVuoJTF0+5YEgkk7U4ky7BQSjvvdS/NziXncKW2H2cUSLrifzj8SAubQc4R+USQwhoTBFIAJwRSACQrSbQ7Fs8t6lur/sTiPCuvcvuYvu3zTXjXrktGgfSG+MWblHzDxPCxpsjPZfcZLzCaJwcgkAIeLARSACQrSbQ7Fs8t6qTQCGU22XAoTwCVDWm6B4cHjtyT49nR9olcHaVmZ58zopfSBzSZ5bI7Aimlx8y+FwKpHFtkL4l2xzKqUIKOUrNRdEUurWFM4RjCUHc4J+Ou5Np+nMMf9LewsBEZ1WwLcth9zvAhEaQUjeHEPRBIiYGXfLsIw1WuutHn9LTUuefyD82OJbfIbEIgra/pboKa4EUll+9O3lfTjxFIJVg0bxkQSHn5F3V39WGWUU+5clXsTemk3NoTtaPOmyrK6C7Ip7+cPOswJQJpqvF79z0AABFvSURBVIdFf1Epwa8RSMFWyPqMBpcyc0IEUmYDlHR7aVxelPJcq1imJBNDI3TwZ+Tt8fcUORSdlUQOfyRK9kbFQkaddzavnE0IpKcOPTAYDu+eV9cef0cg9YCVOwo6rajKL7AIpAB/QCAFQLKSRB7A30hd365Y32QPoeab46j+BpZEb9lZ2GmulnLZZu2MmxBI62ua802y20SxTZmZlWY7wBBbKquVe5/iBJJ3cDkvaPjx1vfsKMktIkwKddVLFknQj37lW6ae0i8izDtLEjWcxQiBNJVOVtGayqcRSMGkk728BpeowISlCqQxKiMTC0vwC+Xw7bhKCaMwEY5Jaf5YhtEjpr56Lb+wRCAhkDTaVCJIGhTrzqNsgTRWSc8MNs7dYvX4h1TuFWF4LWkkoXv6rvcPus2XlXkli4AplzsouzhRw+6Lw/1H7g8qQKRECKSpYJv25a0aE0EKfqiIIAWgqkAgjWpxRqIRn2TILcCiCySJMMwyErbSUd60QHEWvkQax1Ny8bsXzuDCC5uOIkWYnF0ErzYE0qF7JQT7FUVfRiD1hEkEqSewBpPXIpC20Jt4yFP7WYTokatC8jkPcYReunlUKe0eKXqUXBRPY9aGQFLeB2kwMBExIIIU3IqY8IdgGnskrE0guWqclmjSZ4kmLWv68fUR5u6MIn45lsl3P7z94sFFF/1Kh8x2LkVERZTrFGHu0aiEyUUxAinYM5IOeQeXSjGh9vNPBEnROJVmVaNA2o4mDTY2vsTcpMU9z8/b+YnkoHUg5rZtpHG5dfGSLX5lhGEjV5hjUp8PLl6qsq6MsG9UNlHcrECKIfYTLppI7fE+aui2RlBryxBIqa1Y3v1qFkijRlk+94kjP1Ie2vJLFGHOjqt01ohLnKGjkS1vb8HP/Fv2P2l2JGNPzz85e+uJa2GIbUR0fa1TbkWa3CE+ygpcAY9AUva+CrOrXSBtIT8hw27/hWG3cA+MFGlxzXr2eSj6S9dHXLMKv3DLzk5pgU1DAkn7AOEmfHhbCD995w2yFcw35N+aCzO2HyAEklarU28+rQgkbwHZEmC4+oXYZ3/Va27/rq9/tMR5JAnOXpvHX7uDnLjfaRnW3VfrsK5w0T6zbgtNUYsntO2fq6OMZK+ibDXvWd7r77GiRpP3y2X3RHVmknaA8zUmkLbfLRBKexg/XuRodMNiQviRIiVFRMgCnusLkkRa4VdkZK0dgaS+1L9Ie/XxZ29bt89WlKgRAqmPNdpP26hAmhRKK4cZepOBr/GkTzmUdPC+SG5dVPheu5PcySz/MGIfG0YUR64YxUUktG2fK5KgvSprwmeqW3QwZrH6mPKhyjMfo1x2J4LUp3WLm7ZxgbQN74T89t9bmGS7iDv4DuMhuVbzINpdmqF7cHjgyD2LlC/WNfGiSK7EdYikyOLojAw5vr+0IcdWBNLIy/Q3P/WPWyX+O36x+7IU+mb5qK1QC2lzEEghlNpOY0UgbVnRrXr7n4Phyl9amKfk30APS50PRnbjIsezIx0/MonyhAiEm0oTCFsFjDSHZbL+Ra7sa0ogPXXoAVmAcnek57e46N9kPb24vyPqi90MsAikSF5XUbbWBNLOzm3QfU/OeXu81A5uGT/yjcvnE7x1nZUG/OOlDmMmmMxZ3DE4CYZTnWsWKYp91MVFG76zzPMzeW3OjjK+yC/vrMvcwmjL9jntPs13lduyYp9fredWIx/LAmmS3zF/KG71Yil941LO/jd7PRDxhil23PHREjYuTSSMRRSv7Cs1CttSBMkLvhfl+1qNBn+PPFxkfU0EwdGI95iZtRf1bijtD3NFjHYXEIGUyxvKuS8C6UJbnJC9Nf7XYGXl2VKjIruL7DdHvEX+f3+CiNHE7SuZxzDeL+XHCR476Wi6r+c4zd6LAhcxjDUJf9LuX8xRx1D7NSiQVCNiMzgmn6s53tW9O5By8nWoHyGQQkm1mw6BNNu2rsN7WZIckzfml0oSTF4U/Ucp2/Xyib7kdQqmqvYEinTm3F7ec0YE2RODc+e+Fnv41keMnB8kEEaj6ha/Aqo1geSgx11wcIEbu4jS8/L5gXZUaTxkeE5e5IY3Sv5Xpn2h69eRI5D68WoxNQKpn1XPSvJT8nlJPsdFNP00xTCDDz9f58XQFQU0LFWJoy0TSycTe6himjeNh2+Hq+tavjLx1r0vcQdThd0bFUipokjTfNhFlk7K51/k89wowXDl5F7+PNFeiet3V8scxXfKFZfL59LE/tqvdd+VGoG0FL4mLkYg6ZjRNSDuxwkn9zNuRFw7EjCu7xt0f0UnjcjwXdKyXCLfFxfYqBQ9KXuWOX3D7Q7nzRFxc0XzEcnhq/L7cfn8dmZHs77mOsXJTuYDGctejd1bFEgjN8gj8HVayApzQSBVaDTlIiOQlIE2nl01neRedvBDk38rf0+6p0oDfvGJELFfQj2bFUij4alNJ/Dx3QSOhkBKALnwWyCQCjdQQcU7LdGOP9YaJspZL0RSX/rlr1ScrFGrAmkcRYpy/Ehfhyg1vZsCoSYeEUilmjlduRBI6VjXfKcq5p70AexFUoqVbX2KVWDausTRWESMhiab2AdpmkNEPk+xQB8MKtIJeYH7lETY3KIalR8EkgrGqjNBIFVtvhSFr2Mp/yIkEu0ZtEjRCrmmPnFkQiCNj9/IOZeuEP/cLsb2juAijjutwiGQtEjWmw8CqV7bxS65hKu7r5a8340GAIbb9qJYpziyIJBGdWQ+ksMgw/7Dz05uv4JACm4V2Uk7AFV5Amm8T8ZfyAqu1EuYA3CZSTIKV7cw3yjEYoikHZTcPI7P1Xywc+tDbFvWMu63T8rO9Xfu3mcMgRTS4o3SIJACUBUnkLYffhdGXl29S94QPin/F+8U+gBIhpKclX1L/mp44Mg9huo8qmoBWwCUgLy4c+UWgWJFII0jSaNd4i2typwp4BFIwU8MAikAVbECabLs4wav+88lbkcfwLiWJG638DusRI32Mor42nflbwdrMZpiOY/JG/nB2Dt/K5Z3z6wsCSRjImmujyKQgp8wBFIAqioE0pSo0sfk/3Jt9heAtaokp6W099ayx00KsuOdqgf/TT5qS4ZTlHvBezQXNbQmkAxEQIOHfRFIwa0AAikAVVUCaUdUaTxJ0R3O+WH5MAQXYOxdSbIdrNq/qOmvGA+5rT7WeNSyyblmFgXSeZHUnM9OnWs0IwLMKraw5hKBFMCpWoG0UyyNxuHdafaIpflGl4hR983WV6fNxxCWwne2ToinOgw2rGDLpXKHkd5X80TsWdW3KpC2mLSxfcXo/MIv9B3yJ4IU3DAgkAJQNSGQpoilnKfcB2DPkkQOTR08wlDaYux9p3NH5dFKN1RxVHzg1sUo1HGVdYE0iiaNI+zfqk/YLyaMzotD9kEKfEoRSAGgmhNIO8XSaMuA/X6Y5Er5m4U5JZMIzkhk7YnByurf9H0TC/Adk0m8UHICvKaI0mg4dbBx7vEWJmHPczwE0nlCnsVDhQv7kXCXRSJ/uWw7RQRp3tOx/XcEUgCqpgXS7vqPlsRubt4gWwf8gfytVcHkhk+elzo+NrmBWoAvkKQHgfHy6s07y96vS97GB8NvW4saIpAudGQv7P9U/lLS4haJao926r+/x6M3MykCKZgkAikAlSmBNFUwdZvXSCfyXvnb5ZVFBbaq496+jkuk6O+JFAV4fIQk41Vv3QHxo6syv6mPfUE6HSvRogjmbDrLiS1TcmzEi3827V3tVc60QJpmTr/x2u+PI0zdJdLpXSy/XyqfEobnXHTo1/J5Scr2S5nEuL5sSLo9l85bo11RSudHMVdY+g5n8Irc5zlrkaK8lq7/7gmEvfPPU+P2Cv+s32Ps1QCB1MPmfuKjizS9dSygtn8kCrXj5x09O8Yt4eMz6V4TYfaq/8dz7pvOr4ehCkvq39pFZA/fNSG6XSnn+clWB+PSvi6fVyRS+DsZPv2ZbOr4goX5RIWZstniTLRt10/46JulwrOG5C70zzGh52Q+0Ule3pp1FzMVQyCZMTUVhQAEIAABCEAglAACKZQU6SAAAQhAAAIQMEMAgWTG1FQUAhCAAAQgAIFQAgikUFKkgwAEIAABCEDADAEEkhlTU1EIQAACEIAABEIJIJBCSZEOAhCAAAQgAAEzBBBIZkxNRSEAAQhAAAIQCCWAQAolRToIQAACEIAABMwQQCCZMTUVhQAEIAABCEAglAACKZQU6SAAAQhAAAIQMEMAgWTG1FQUAhCAAAQgAIFQAgikUFKkgwAEIAABCEDADAEEkhlTU1EIQAACEIAABEIJIJBCSZEOAhCAAAQgAAEzBBBIZkxNRSEAAQhAAAIQCCWAQAolRToIQAACEIAABMwQQCCZMTUVhQAEIAABCEAglAACKZQU6SAAAQhAAAIQMEMAgWTG1FQUAhCAAAQgAIFQAgikUFKkgwAEIAABCEDADAEEkhlTU1EIQAACEIAABEIJIJBCSZEOAhCAAAQgAAEzBBBIZkxNRSEAAQhAAAIQCCWAQAolRToIQAACEIAABMwQQCCZMTUVhQAEIAABCEAglAACKZQU6SAAAQhAAAIQMEMAgWTG1FQUAhCAAAQgAIFQAgikUFKkgwAEIAABCEDADAEEkhlTU1EIQAACEIAABEIJIJBCSZEOAhCAAAQgAAEzBBBIZkxNRSEAAQhAAAIQCCWAQAolRToIQAACEIAABMwQQCCZMTUVhQAEIAABCEAglAACKZQU6SAAAQhAAAIQMEMAgWTG1FQUAhCAAAQgAIFQAgikUFKkgwAEIAABCEDADAEEkhlTU1EIQAACEIAABEIJIJBCSZEOAhCAAAQgAAEzBBBIZkxNRSEAAQhAAAIQCCWAQAolRToIQAACEIAABMwQQCCZMTUVhQAEIAABCEAglAACKZQU6SAAAQhAAAIQMEMAgWTG1FQUAhCAAAQgAIFQAgikUFKkgwAEIAABCEDADAEEkhlTU1EIQAACEIAABEIJIJBCSZEOAhCAAAQgAAEzBBBIZkxNRSEAAQhAAAIQCCWAQAolRToIQAACEIAABMwQQCCZMTUVhQAEIAABCEAglAACKZQU6SAAAQhAAAIQMEMAgWTG1FQUAhCAAAQgAIFQAgikUFKkgwAEIAABCEDADAEEkhlTU1EIQAACEIAABEIJIJBCSZEOAhCAAAQgAAEzBBBIZkxNRSEAAQhAAAIQCCWAQAolRToIQAACEIAABMwQQCCZMTUVhQAEIAABCEAglAACKZQU6SAAAQhAAAIQMEMAgWTG1FQUAhCAAAQgAIFQAgikUFKkgwAEIAABCEDADAEEkhlTU1EIQAACEIAABEIJIJBCSZEOAhCAAAQgAAEzBBBIZkxNRSEAAQhAAAIQCCWAQAolRToIQAACEIAABMwQQCCZMTUVhQAEIAABCEAglAACKZQU6SAAAQhAAAIQMEMAgWTG1FQUAhCAAAQgAIFQAgikUFKkgwAEIAABCEDADAEEkhlTU1EIQAACEIAABEIJIJBCSZEOAhCAAAQgAAEzBBBIZkxNRSEAAQhAAAIQCCWAQAolRToIQAACEIAABMwQQCCZMTUVhQAEIAABCEAglAACKZQU6SAAAQhAAAIQMEMAgWTG1FQUAhCAAAQgAIFQAgikUFKkgwAEIAABCEDADAEEkhlTU1EIQAACEIAABEIJIJBCSZEOAhCAAAQgAAEzBBBIZkxNRSEAAQhAAAIQCCWAQAolRToIQAACEIAABMwQQCCZMTUVhQAEIAABCEAglAACKZQU6SAAAQhAAAIQMEMAgWTG1FQUAhCAAAQgAIFQAgikUFKkgwAEIAABCEDADAEEkhlTU1EIQAACEIAABEIJIJBCSZEOAhCAAAQgAAEzBBBIZkxNRSEAAQhAAAIQCCWAQAolRToIQAACEIAABMwQQCCZMTUVhQAEIAABCEAglAACKZQU6SAAAQhAAAIQMEPg/wM5p8dKx5OdzwAAAABJRU5ErkJggg==",
    width: 146,
    height: 75,
    x: 147,
    y: 126.5
  })))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-6"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M291.9 352.72h296v116.2h-296z",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("switch", {
    transform: "matrix(2 0 0 2 -.5 -.5)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 146,
      height: 1,
      paddingTop: 205,
      marginLeft: 147
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFB570;",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 52,
      fontFamily: "&quot",
      color: "#ffb570",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "1")))), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,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",
    width: 146,
    height: 75,
    x: 147,
    y: 174.5
  })))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-7"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M102.72 502.72h202.36v56.2H102.72z",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("switch", {
    transform: "matrix(2 0 0 2 -.5 -.5)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 99,
      height: 1,
      paddingTop: 265,
      marginLeft: 53
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFB570;",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 15,
      fontFamily: "&quot",
      color: "#ffb570",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Standard")))), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,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",
    width: 99,
    height: 21.75,
    x: 53,
    y: 256.5
  })))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-8"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M575.9 502.72h220v56.2h-220z",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("switch", {
    className: "solarStandard_svg__testTwoClass",
    transform: "matrix(2 0 0 2 -.5 -.5)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 108,
      height: 1,
      paddingTop: 265,
      marginLeft: 290
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFB570;",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 15,
      fontFamily: "&quot",
      color: "#ffb570",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontStyle: "italic",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }))), _div || (_div = /*#__PURE__*/React.createElement("div", {
    className: "solarStandard_svg__div-svg-hydroSolar"
  })))))), _image4 || (_image4 = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,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",
    width: 108,
    height: 39.75,
    x: 290,
    y: 247.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-14",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m133 64 30 14.4v3.2L133 96l-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m103 78.4 30 14.41 30-14.41m-30 14.41V96"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-15",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m177 42 30 14.4v3.2L177 74l-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m147 56.4 30 14.41 30-14.41m-30 14.41V74"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-16",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m179 88 30 14.4v3.2L179 120l-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m149 102.4 30 14.41 30-14.41m-30 14.41V120"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-17",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m222.06 66 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m192.06 80.4 30 14.41 30-14.41m-30 14.41V98"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-18",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m137 110 30 14.4v3.2L137 142l-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m107 124.4 30 14.41 30-14.41m-30 14.41V142"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-21",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m77 140 30 14.4v3.2L77 172l-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m47 154.4 30 14.41 30-14.41m-30 14.41V172"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-22",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m267 46 30 14.4v3.2L267 78l-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m237 60.4 30 14.41 30-14.41m-30 14.41V78"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffb570",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m67.308 196.185 250.604-127.69",
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-24",
    pointerEvents: "all"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 4,
    d: "M352.261 215.179 82.84 77.9",
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-25",
    pointerEvents: "all"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 4,
    d: "M388.902 188.539 148.918 66.26",
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-26",
    pointerEvents: "all"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 4,
    d: "m436.545 168.405-206.25-105.09",
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-27",
    pointerEvents: "all"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "m493.235 139.715-151.81-77.35",
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-28",
    pointerEvents: "all"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M308.372 236.397 64.628 112.203",
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-29",
    pointerEvents: "all"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-30",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m257 172.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m227 187.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-31",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m301 150.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m271 165.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-32",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m303 196.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m273 211.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-33",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m347 174.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m317 189.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-34",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m245 226.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m215 241.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-35",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m347 128.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m317 143.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-36",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m211 150.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m181 165.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-37",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m257 130.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m227 145.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-38",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m201 248.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m171 263.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-39",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m393 152.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m363 167.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-40",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m435 130.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m405 145.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffb570",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m61.65 372.2 611-311.32",
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-41",
    pointerEvents: "all"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-42",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m195 203.68 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m165 218.08 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-43",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m301 107.56 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m271 121.96 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-44",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m389 107.56 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m359 121.96 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-45",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m342.98 84 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m312.98 98.4 30 14.41 30-14.41m-30 14.41V116"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 4,
    d: "m247.305 268.29-183.03-93.26",
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-46",
    pointerEvents: "all"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 4,
    d: "m204.836 288.235-144.872-72.23",
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-47",
    pointerEvents: "all"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 4,
    d: "m578.528 97.928-71.156-36.256",
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-48",
    pointerEvents: "all"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-49",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m492.56 102 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m462.56 116.4 30 14.41 30-14.41m-30 14.41V134"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-52",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m157 269.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m127 284.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-53",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m115.36 291.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m85.36 306.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 4,
    d: "m159.57 308.903-99.24-50.566",
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-54",
    pointerEvents: "all"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-58",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m445.62 78 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m415.62 92.4 30 14.41 30-14.41m-30 14.41V110"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-59",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m401 56 30 14.4v3.2L401 88l-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m371 70.4 30 14.41 30-14.41m-30 14.41V88"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M485.793 144.491 323.167 61.63",
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-60",
    pointerEvents: "all"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "m477.889 148.995-171.198-87.23",
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-61",
    pointerEvents: "all"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M298.547 239.16 62.253 118.76",
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-62",
    pointerEvents: "all"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M291.362 243.578 67.398 129.462",
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-63",
    pointerEvents: "all"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-64",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m151 181.7 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m121 196.1 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-65",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m151 224.82 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m121 239.22 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-66",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m107.36 203.68 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m77.36 218.08 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-67",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m122.36 255.9 23 11.04v2.5l-23 11.04-23-11.04v-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m99.36 266.94 23 11.05 23-11.05m-23 11.05v2.49"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffb570",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M69.881 206.856 355.7 61.224",
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-70",
    pointerEvents: "all"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-71",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m87 86 30 14.4v3.2L87 118l-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m57 100.4 30 14.41 30-14.41m-30 14.41V118"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 4,
    d: "M536.672 118.743 425.028 61.857",
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-74",
    pointerEvents: "all"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-75",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m535.18 80.16 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m505.18 94.56 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-76",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m488.24 56.16 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m458.24 70.56 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-78",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m576.14 60 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m546.14 74.4 30 14.41 30-14.41m-30 14.41V92"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 4,
    d: "m622.338 77.962-33.056-16.844",
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-81",
    pointerEvents: "all"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeWidth: 8,
    d: "M60.623 361.788 635.857 68.692",
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-86",
    pointerEvents: "all"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeWidth: 8,
    d: "M67.443 186.212 297.037 69.228",
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-87",
    pointerEvents: "all"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M68.477 214.82 370.563 60.9",
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-88",
    pointerEvents: "all"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-93",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m93.36 239.84 23 11.04v2.5l-23 11.04-23-11.04v-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m70.36 250.88 23 11.05 23-11.05m-23 11.05v2.49"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-94",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m84 277.22 23 11.04v2.5L84 301.8l-23-11.04v-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m61 288.26 23 11.05 23-11.05m-23 11.05v2.49"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "P6W03vUlQnAWO8og2PQN-95",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m541.14 53.44 16 7.68v1.76l-16 7.68-16-7.68v-1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m525.14 61.12 16 7.69 16-7.69m-16 7.69v1.75"
  })))))));
};
export default SvgSolarStandard;